<template>
  <div class="pg-page-wrapper">
    <router-view v-if="isMobile"></router-view>
    <pc v-else></pc>
  </div>
</template>

<script>
import pc from './pc.vue'
import mobile from './mobile.vue'
import End from "~/components/End";
import { isMobile, isWeiXin } from '~/tools/utils'

export default {
  components: {
    pc,
    mobile
  },
  data() {
    return {
      isMobile: isMobile(),
      isWeiXin: isWeiXin()
    }
  },
  mounted() {
    // TODO 需更新活动结束时间
    if(new Date()*1 >= new Date('2024-07-01 00:00:00.000')*1) {
      End("活动已结束");
    } else if(this.isMobile && !this.isWeiXin) {
      // 微信提示
      End("请在微信中访问");
    }
  }
}
</script>

<style rel="stylesheet/stylus" lang="stylus" scoped>
  .pg-page-wrapper
    width: 100%;
</style>
